var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 2.9488C6.10564 2.9488 2.94868 6.10577 2.94868 10.0001C2.94868 13.8944 6.10564 17.0514 9.99996 17.0514C13.8943 17.0514 17.0512 13.8944 17.0512 10.0001C17.0512 6.10577 13.8943 2.9488 9.99996 2.9488ZM1.66663 10.0001C1.66663 5.39771 5.39759 1.66675 9.99996 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001C18.3333 14.6025 14.6023 18.3334 9.99996 18.3334C5.39759 18.3334 1.66663 14.6025 1.66663 10.0001ZM9.99996 5.94025C10.354 5.94025 10.641 6.22725 10.641 6.58128V9.73456L13.0173 12.1109C13.2677 12.3612 13.2677 12.7671 13.0173 13.0175C12.767 13.2678 12.3611 13.2678 12.1108 13.0175L9.54669 10.4534C9.42647 10.3331 9.35893 10.1701 9.35893 10.0001V6.58128C9.35893 6.22725 9.64593 5.94025 9.99996 5.94025Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyClock);
export default __webpack_public_path__ + "static/media/grey-clock.56f3a090f9e1b93662140e7b9e220fa2.svg";
export { ForwardRef as ReactComponent };